import sanitize from "sanitize-html";

export const useSanitize = () => {
  const sanitizeHtml = (dirty: string, options?: sanitize.IOptions) => {
    options = {
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
      transformTags: {
        a: sanitize.simpleTransform("a", {
          target: "_blank",
          rel: "nofollow noopener",
        }),
      },
      ...options,
    };
    return sanitize(dirty, options);
  };

  return { sanitizeHtml };
};
